var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1618873644(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9105,
    cy: 12.885,
    rx: 12.68,
    ry: 12.885,
    fill: "#936FE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69599 20.0539V17.9768L11.1831 16.2321V13.2412L4.55078 15.8998V13.4073L11.1831 8.75475V5.09914C11.1831 4.64219 11.3456 4.25115 11.6706 3.92602C11.9956 3.6009 12.3858 3.43806 12.8412 3.4375C13.2966 3.43695 13.6871 3.59979 14.0126 3.92602C14.3382 4.25226 14.5004 4.6433 14.4993 5.09914V8.75475L21.1316 13.4073V15.8998L14.4993 13.2412V16.2321L16.9864 17.9768V20.0539L12.8412 18.8077L8.69599 20.0539Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1618873644);
export default __webpack_public_path__ + "static/media/Group 1618873644.8bba1dcf2dd6139f9939258e224ec0e3.svg";
export { ForwardRef as ReactComponent };